import type { Id } from '@goaltree/backend/convex/_generated/dataModel'
import { create } from 'zustand'

import { markBrainDumpUsed } from '@/lib/first-run'

// What the tab bar's mic does while the panel is open: stop a recording, resume or start one.
export type CaptureMic = 'listening' | 'paused' | 'ready' | null

// A coach chat (threadId) or a just-ended call (since = its start) to read as a brain dump.
export type CaptureConversation = { threadId?: Id<'coachThreads'> | null; since?: number }

interface CaptureState {
  open: boolean
  busy: boolean
  mic: CaptureMic
  micAction: (() => void) | null
  conversation: CaptureConversation | null
  setOpen: (open: boolean) => void
  setBusy: (busy: boolean) => void
  setMic: (mic: CaptureMic, action: (() => void) | null) => void
}

export const useCaptureStore = create<CaptureState>((set, get) => ({
  open: false,
  busy: false,
  mic: null,
  micAction: null,
  conversation: null,
  setOpen: (open) => {
    if (!open && get().busy) return
    if (open) markBrainDumpUsed()
    set(open ? { open } : { open, conversation: null })
  },
  setBusy: (busy) => set({ busy }),
  setMic: (mic, micAction) => set({ mic, micAction }),
}))

export const openCapture = () => useCaptureStore.getState().setOpen(true)

export const openConversationCapture = (conversation: CaptureConversation) => {
  markBrainDumpUsed()
  useCaptureStore.setState({ open: true, conversation })
}
